import React, { useRef, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom'; // 更新导入
import { Stack,Divider,Avatar, Container, Typography, Grid, Paper, AppBar, Toolbar, CssBaseline, Box, Button, TextField, ListItem, ListItemIcon, ListItemText, Drawer, List, Menu, MenuItem } from '@mui/material';
import { FixedSizeList } from "react-window"; // 导入 FixedSizeList
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'; // 导入菜单图标
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import SensorsIcon from '@mui/icons-material/Sensors';
import EditIcon from '@mui/icons-material/Edit';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import GroupIcon from '@mui/icons-material/Group';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import KeyIcon from '@mui/icons-material/Key';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { format } from 'date-fns';

function MainAppBar({ userData }) {

    const notification = userData.notification ? userData.notification.sort((a, b) => new Date(b.date) - new Date(a.date)) : [];

    const [MenuOpen, setMenuOpen] = useState(false); // 新增状态以控制 Drawer
    const [anchorEl, setAnchorEl] = useState(null); // 新增状态以控制下拉菜单
    const [anchorE2, setAnchorE2] = useState(null); // 新增状态以控制下拉菜单
    const [menuOptionsOpen, setMenuOptionsOpen] = useState(false); // 新增状态以控制下拉菜单
    const navigate = useNavigate(); // 创建 navigate 函数

    const fetchUserLogout = async () => {
        try {
            const response = await fetch('/api/user/logout');
            if(response.ok){
            window.location.href = '/login';
            }
        } catch (error) {
            console.error('Error fetching last record:', error);
        }
    };
    
    const handleMenuClickOpen = () => {
    setMenuOpen(!MenuOpen);
    };

    const handleMenuClickClose = () => {
    setMenuOpen(false);
    };

    const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // 设菜单锚点
    };

    const handleMenuClose = () => {
    setAnchorEl(null); // 关闭菜单
    };
    
    const handleNotificationClick = (event) => {
        setAnchorE2(event.currentTarget); // 设菜单锚点
    };


    const handleNotificationClose = () => {
        setAnchorE2(null); // 关闭菜单
    };

    return (
        <AppBar position="static" style={{backgroundColor: '#222222'}}>
            
        <Toolbar>
            <Typography variant="h6" style={{ flexGrow: 1 }}>BEE IOT DASHBOARD</Typography> {/* 添加 flexGrow 以推送内容到右侧 */}
          <Typography variant="h6" style={{ flexGrow: 1 }}></Typography> {/* 添加 flexGrow 以推送内容到右侧 */}
          {false && (<IconButton color="inherit" onClick={handleNotificationClick}>
            <NotificationsIcon />
          </IconButton>)}
          
          <Typography variant="h6" style={{ padding: '8px', display: 'flex', alignItems: 'center' }}>
            <img 
              src={userData.picture} 
              alt="User Avatar" 
              style={{ width: '40px', borderRadius: '50%', marginRight: '8px', cursor: 'pointer' }} // 添加光标样式
              onClick={handleMenuOpen}
            />
          </Typography>
        </Toolbar>
        
        <Drawer variant="permanent" anchor="bottom" open={MenuOpen} onClose={handleMenuClickClose} >
            <Stack direction="row" spacing={3} alignItems="center" justifyContent="center" height={window.innerWidth > 500 ? 60 :60}>
                <Stack direction="column" alignItems="center" justifyContent="center">
                    <IconButton onClick={() => navigate('/sensors')} size="large" style={{padding: '0px'}}>
                        <SensorsIcon />
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>SENSORS</Typography>
                </Stack>

                <Stack direction="column" alignItems="center" justifyContent="center">  
                    <IconButton onClick={() => navigate('/aqmesh')} size="large" style={{padding: '0px'}}>
                        <FmdGoodIcon /> 
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>WEATHER</Typography>
                </Stack>

                <Stack direction="column" alignItems="center" justifyContent="center">
                    <IconButton onClick={() => navigate('/people')} size="large" style={{padding: '0px'}}>
                        <PersonPinCircleIcon />
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>PEOPLE</Typography>
                </Stack>

                <Stack direction="column" alignItems="center" justifyContent="center">
                    <IconButton onClick={() => navigate('/trends')} size="large" style={{padding: '0px'}}>
                        <SignalCellularAltIcon />
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>TRENDS</Typography>
                </Stack>

                <Stack direction="column" alignItems="center" justifyContent="center">
                    <IconButton onClick={() => navigate('/location')} size="large" style={{padding: '0px'}}>
                        <FmdGoodIcon />
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>LOCATION</Typography>
                </Stack>

                <Stack direction="column" alignItems="center" justifyContent="center">
                    <IconButton onClick={() => navigate('/device-status')} size="large" style={{padding: '0px'}}>
                        <MonitorHeartIcon />
                    </IconButton>
                    <Typography variant="body1" fontSize={12}>STATUS</Typography>
                </Stack>
            </Stack>

        <Menu 
        anchorEl={anchorEl} 
        open={Boolean(anchorEl) && !menuOptionsOpen} 
        onClose={handleMenuClose} 
        PaperProps={{ style: { width: 250, borderRadius: '16px' } }} // 设置固定宽度并添加圆角
        >
        <ListItemIcon style={{paddingTop: '3px',paddingBottom: '10px',paddingLeft: '5px',paddingRight: '10px'}}>
        <img 
            src={userData.picture} 
            alt="User Avatar" 
            style={{ width: '50px', borderRadius: '50%', marginLeft: '8px',marginRight: '8px'}} // 添加光标样式
        />
        {userData.name} <br /> {/* 添加换行 */}
        @{userData.email.split('@')[0]}
        </ListItemIcon>
        <Divider /> {/* 添加分隔线 */}
        {false && (
            <MenuItem onClick={() => navigate('/settings')}>
                <ListItemIcon>
                <SettingsIcon />
                </ListItemIcon>
                Settings
            </MenuItem>
        )}
        

        {false && (<MenuItem onClick={() => setMenuOptionsOpen(true)} anchorEl={anchorEl}> {/* 修为使用 anchorEl */} {/* 新增打开主题选项的逻辑 */}
            <ListItemIcon>
            <Brightness4Icon /> {/* 添加主题切换图标 */}
            </ListItemIcon>
            Dark Mode
        </MenuItem>)}

        {userData.is_active && (<MenuItem onClick={() => navigate('/edit')}>
            <ListItemIcon>
            <EditIcon /> {/* 添加设置图标 */}
            </ListItemIcon>
            Edit
        </MenuItem>)}

        { userData.is_admin && (<MenuItem onClick={() => navigate('/users')}>
            <ListItemIcon>
            <GroupIcon /> {/* 添加设置图标 */}
            </ListItemIcon>
            Users
        </MenuItem>)}

        {userData.is_active && (<MenuItem onClick={() => navigate('/hierarchy')}>
            <ListItemIcon>
            <AccountTreeIcon />
            </ListItemIcon>
            Hierarchy
        </MenuItem>)}

        {userData.is_active && (<MenuItem onClick={() => navigate('/userAPI')}>
            <ListItemIcon>
            <KeyIcon /> {/* 添加设置图标 */}
            </ListItemIcon>
            API KEY
        </MenuItem>)}
        
        <Divider /> {/* 添加分隔线 */}
        <MenuItem onClick={fetchUserLogout}>
            <ListItemIcon>
            <LogoutIcon /> {/* 添加登出图标 */}
            </ListItemIcon>
            Logout
        </MenuItem> {/* 添加登出选项 */}
        </Menu>

        <Menu 
        anchorEl={anchorE2} 
        open={Boolean(anchorE2)} 
        onClose={handleNotificationClose} 
        PaperProps={{ style: { width: 300, borderRadius: '16px' } }} // 设置固定宽度并添加圆角
        >
        {notification?.map((item, index) =>
            <MenuItem key={index} onClick={() => navigate('/dashboard', { state: { notification: item.name } })}>
            <ListItemIcon>
                <NotificationsIcon />
            </ListItemIcon>
            <Typography variant="body1">
                {item.notificationtype} <br/> {item.name} <br /> {new Date(item.date).toLocaleString()}<br/>
            </Typography>
            </MenuItem>
        )}
        </Menu>
        
      </Drawer>
      </AppBar>
    )
}
   
export default MainAppBar; // 导出 AppBar 组件
